import Bal from "../components/Bal";
import CaptionCarousel from "../components/CarouselLandingScreen";
import HomeServices from "../components/HomeServices";
import Koszonolevel from "../components/Koszonolevel";
import WhyDifferent from "../components/WhyDifferent";
import Youtube from "../components/Youtube";
export default function LandingScreen() {
  return (
    <>
      <CaptionCarousel />
      {/* <Box py={10}>
        <Container maxW="container.xl">
        <HirekList />
        </Container>
      </Box> */}
      <WhyDifferent />
      {/* <Bal/> */}
      <Koszonolevel/>
      <Youtube/>
      <HomeServices />
      {/* <SzolgSection />
      <AboutSection /> */}


    </>
  );
}
